module.exports = __webpack_public_path__ + "static/img_2712_optimized-39e4d09c0799b24be0cda0050f6afc21.jpg";